import React, { useContext } from 'react'
import moment from 'moment'
import 'moment/locale/es'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import EntityContext from '../../../contexts/Entity'
import { EntityContextType } from '../../../schemas/Entity'
import { usePlanStatus } from '../../../hooks/usePlanStatus'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    expired: {
      width: '100%',
      backgroundColor: '#ffebee',
      color: '#c62828',
      borderBottom: '1px solid #ef9a9a',
      padding: '6px 16px',
      fontSize: 12,
      fontWeight: 500,
      textAlign: 'center' as const,
    },
    expiring: {
      width: '100%',
      backgroundColor: '#fffde7',
      color: '#f57f17',
      borderBottom: '1px solid #ffe082',
      padding: '6px 16px',
      fontSize: 12,
      fontWeight: 500,
      textAlign: 'center' as const,
    },
  })
)

export default function PlanStatusBanner() {
  const classes = useStyles()
  const { entityContext } = useContext(EntityContext) as EntityContextType
  const { planExpiredAt } = entityContext
  const { isExpired, isExpiringSoon, daysUntilExpiry, deactivationDate } = usePlanStatus(planExpiredAt)
  const expiryDateObj = planExpiredAt ? new Date(planExpiredAt) : new Date()

  if (isExpired) {
    return (
      <div className={classes.expired}>
        Tu plan ha vencido. El acceso será inactivado el{' '}
        {deactivationDate ? moment(deactivationDate).locale('es').format('D [de] MMMM [de] YYYY') : ''}.
      </div>
    )
  }

  if (isExpiringSoon) {
    return (
      <div className={classes.expiring}>
        Tu plan vence en <strong>{daysUntilExpiry} {daysUntilExpiry === 1 ? 'día' : 'días'}</strong>{' '}
        ({moment(expiryDateObj).locale('es').format('D [de] MMMM [de] YYYY')}). ¡Renuévalo pronto!
      </div>
    )
  }

  return null
}
